import React from 'react';
import { Button, Typography, message } from 'antd';
import {
  PlaySupport,
  ChatBuubble,
  EmailSupport,
  BookOpenIcon,
} from '@/assets/icons/icons';
import { GetProductManual } from '@/apis/auth';
import './help.css';

type HelpMenuDropdownProps = {
  showChat?: boolean;
  onWatchTour: () => void;
  onOpenChat: () => void;
  onClose?: () => void;
  supportEmail?: string;
  mailSubject?: string;
};

const DEFAULT_EMAIL = 'support@zoomlogi.com';
const DEFAULT_SUBJECT = 'Zoomlogi support request';

// const buildGmailCompose = (email: string, subject: string, body: string) => {
//   const params = new URLSearchParams();
//   params.set('to', email);
//   if (subject) params.set('su', subject);
//   if (body) params.set('body', body);
//   return `https://mail.google.com/mail/?view=cm&fs=1&${params.toString()}`;
// };

const openMailClient = (to: string, subject: string, body: string) => {
  const mailto = `mailto:${to}?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(body)}`;

  window.location.href = mailto;
};

const HelpMenuDropdown: React.FC<HelpMenuDropdownProps> = ({
  showChat = true,
  onWatchTour,
  onOpenChat,
  onClose,
  supportEmail = DEFAULT_EMAIL,
  mailSubject = DEFAULT_SUBJECT,
}) => {
  const onEmailRowClick = () => {
    //return;
    onClose?.();

    const subject = mailSubject;
    const body = `Please describe your issue:\n\n`;
    openMailClient(supportEmail, subject, body);

    // const url = buildGmailCompose(supportEmail, subject, body);

    // window.open(url, '_blank', 'noopener,noreferrer');
  };

  const onDownloadManual = async () => {
    onClose?.();
    try {
      const res = await GetProductManual();
      const url = res?.data?.data?.data?.manual_url;
      if (!url) {
        message.error('Could not retrieve product manual');
        return;
      }
      const response = await fetch(url);
      if (!response.ok) throw new Error('Download failed');
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = 'Zoomlogi-Product-Manual.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch {
      message.error('Could not retrieve product manual');
    }
  };

  const onCopyEmail = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(supportEmail);
      message.success('Copied');
    } catch {
      message.error('Could not copy');
    }
  };

  return (
    <div className='helpDropdown' role='menu'>
      <div className='helpDropdown__header'>
        <Typography.Text className='helpDropdown__title'>Help</Typography.Text>
      </div>

      <button
        type='button'
        className='helpItem helpItem--primary'
        onClick={onWatchTour}
      >
        <span className='helpItem__icon helpItem__icon--primary'>
          <PlaySupport width={18} height={18} color='#fff' />
        </span>

        <span className='helpItem__content'>
          <span className='helpItem__label'>Watch 5 min tour</span>
          <span className='helpItem__sub'>Recommended</span>
        </span>
      </button>

      {showChat && (
        <button type='button' className='helpItem' onClick={onOpenChat}>
          <span className='helpItem__icon'>
            <ChatBuubble width={18} height={18} color='var(--text-secondary)' />
          </span>

          <span className='helpItem__content'>
            <span className='helpItem__label'>Chat with support</span>
            <span className='helpItem__sub'>Ask a question, get help</span>
          </span>
        </button>
      )}

      <div
        className='helpItem helpItem--email'
        role='button'
        tabIndex={0}
        onClick={onEmailRowClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') onEmailRowClick();
        }}
      >
        <span className='helpItem__icon'>
          <EmailSupport width={18} height={18} color='var(--text-secondary)' />
        </span>

        <span className='helpItem__content'>
          <span className='helpItem__label'>Email support</span>
          <span className='helpItem__sub'>{supportEmail}</span>
        </span>

        <Button
          className='helpItem__copyBtn'
          type='default'
          onClick={onCopyEmail}
        >
          Copy
        </Button>
      </div>

      <button type='button' className='helpItem' onClick={onDownloadManual}>
        <span className='helpItem__icon'>
          <BookOpenIcon width={18} height={18} color='var(--text-secondary)' />
        </span>

        <span className='helpItem__content'>
          <span className='helpItem__label'>Product manual</span>
          <span className='helpItem__sub'>Click here to download pdf</span>
        </span>
      </button>
    </div>
  );
};

export default HelpMenuDropdown;
